import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { SeasonsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export const useSeasonGet = (id: number) => {
  const accessToken = useAccessToken();

  const { data, isError, isLoading, isSuccess, isPending, refetch } = useQuery({
    queryKey: [QueryKeys.Seasons, id],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(SeasonsApi, accessToken);
      return service.getSeasonById({ id });
    },
    enabled: !!accessToken && !!id,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    refetch,
  };
};

